/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */

import React from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Button } from "react-bootstrap";
import {
  AudioElement,
  ImageElement,
  ModalComponent,
  VideoElement,
} from "components/UiElement";
import { ext } from "helpers";
import { checkValidData } from "components/Formatter";
import { Navigation, Pagination } from "swiper/modules";
import { SwiperSlide, Swiper } from "swiper/react";

// Initialize Swiper core components

function CapturedModel({ handleCloseModal1, showModal1, photoData }) {
  const openPdf = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  const imgName = (media) => {
    if (media) {
      let name = media?.substring(media?.lastIndexOf("/") + 1);
      return name;
    }
  };

  return (
    <ModalComponent
      size="md"
      show={showModal1}
      onHandleCancel={() => {
        handleCloseModal1();
      }}
      extraClassName="imageSlider imageSlider-slideContent"
      backdropClassName="sliderBack"
      pagination={{ clickable: true }}
      closeVariant="white"
    >
      <div className="slider">
        <h2 className="text-center">{checkValidData(photoData?.name)}</h2>
        <Swiper
          extraClassName="d-flex flex-column justify-content-bwteen align-items-center"
          spaceBetween={20}
          slidesPerView={1}
          centeredSlides
          loop={photoData?.albumPhotos?.length > 2}
          autoplay={{
            delay: 2500,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={{
            nextEl: ".nextArrow",
            prevEl: ".prevArrow",
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
              autoHeight: true,
            },
            575: {
              slidesPerView: 1.3,
              spaceBetween: 10,
              autoHeight: true,
            },
            768: {
              slidesPerView: 1.4,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 1.4,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            1900: {
              slidesPerView: 2.56,
              spaceBetween: 20,
            },
          }}
          modules={[Pagination, Navigation]}
        >
          {photoData?.albumPhotos?.length > 0 ? (
            photoData?.albumPhotos?.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className="slider_content ">
                    {/* <h2>The Early Years</h2> */}
                    <h3 className="text-break">
                      {checkValidData(item?.title)}
                    </h3>
                    <p className="text-break">
                      {checkValidData(item?.description)}
                    </p>
                  </div>
                  {ext?.[item?.albumImageUrl?.split(".")?.pop()] ===
                    "video" && (
                    <div className="imgSlider-video d-flex justify-content-center align-items-center">
                      <VideoElement
                        previewSource={item?.albumImageUrl}
                        extraClassName="z-1 d-block mx-auto mh-100 w-auto"
                        alt="timeline-img"
                        autoPlay
                      />
                    </div>
                  )}
                  {ext?.[item?.albumImageUrl?.split(".")?.pop()] ===
                    "image" && (
                    <ImageElement
                      previewSource={item?.albumImageUrl}
                      className="w-100 z-1 position-relative imgSlider-image object-fit-contain"
                      alt="timeline-img"
                    />
                  )}
                  {ext?.[item?.albumImageUrl?.split(".")?.pop()] ===
                    "audio" && (
                    <div className="imgSlider-audio d-flex justify-content-center align-items-center position-relative">
                      <AudioElement
                        classname="d-block m-auto"
                        previewSource={item?.albumImageUrl}
                        alt="timeline-img"
                      />
                    </div>
                  )}

                  {ext?.[item?.albumImageUrl?.split(".").pop()] === "file" && (
                    <div
                      className="pdfCard pdfCardMap position-relative d-flex align-items-center justify-content-center"
                      onClick={() => openPdf(item?.albumImageUrl)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="pdfCardMap_icon">
                        <em className="icon-pdf" />
                      </div>
                      <h6 className="pdfCard_title text-center mb-0 text-break">
                        {imgName(item?.media)}
                      </h6>
                    </div>
                  )}
                </SwiperSlide>
              );
            })
          ) : (
            <div className="text-center text-white">Album Photos not found</div>
          )}
        </Swiper>
        <div className="slider_btn">
          <Button type="button" className="prev prevArrow">
            <em className="icon-left-arrow" />
          </Button>
          <Button type="button" className="next nextArrow">
            <em className="icon-right-arrow" />
          </Button>
        </div>
      </div>
    </ModalComponent>
  );
}

export default CapturedModel;
